/**
 * The Loading component, used while resources load
 * Keep this component as similar as possible to the resource page importing it
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Card } from "reactstrap";

const OtherOptionsTab = ({ editorTypeId }, context) => {
  return (
    <Container>
      <Row>
        <Col xs={4}>
          <Card>OtherOptionsTab 1</Card>
        </Col>
      </Row>
    </Container>
  );
};

/**  define proptype for the 'translation' function  */
OtherOptionsTab.contextTypes = {
  t: PropTypes.func,
};
export default OtherOptionsTab;
